
export function isCommandCenterEnabled(): boolean {
  return true;
}

export function isCommandCenterShareEnabled(): boolean {
  return true;
}

export function isCommunicationCenterEnabled(): boolean {
  return true;
}

export function isSupportMode(): boolean {
  return new URLSearchParams(window.location.search).get('support') === 'true';
}

export function isPersonalLineRatingEnabled(): boolean {
  return true;
}

/** Agencies (NowCerts agency ids) allowed to see the Renewal Center menu. */
const RENEWAL_CENTER_AGENCY_IDS = new Set([
  '172ad93c-c1f3-4c21-83e5-f4c642e65501',
]);

export function isRenewalCenterEnabled(): boolean {
  const agencyId = (localStorage.getItem('NCAgencyId') || '').trim().toLowerCase();
  return RENEWAL_CENTER_AGENCY_IDS.has(agencyId);
}

export function isCommercialLinesRatingEnabled(): boolean {
  return true;
}

/** Comma-separated agency ids allowed to see a feature, from a REACT_APP_* env var. */
function isAgencyAllowed(envValue: string | undefined): boolean {
  const allowedAgencies = (envValue || '')
    .split(',')
    .map(id => id.trim())
    .filter(Boolean);
  if (allowedAgencies.length === 0) return false;
  const currentAgencyId = localStorage.getItem('NCAgencyId') || '';
  return allowedAgencies.includes(currentAgencyId);
}

/** Opportunity Tracker is limited to the agencies listed in REACT_APP_OPPORTUNITY_TRACKER_AGENCIES. */
export function isOpportunityTrackerEnabled(): boolean {
  return isAgencyAllowed(process.env.REACT_APP_OPPORTUNITY_TRACKER_AGENCIES);
}

export function isMarketplaceEnabled(): boolean {
  return true;
}

export function isMacWorkflowsEnabled(): boolean {
  return false;
}

/** Agencies (NowCerts agency ids) allowed to see the Marketplace sidebar menu. */
const MARKETPLACE_MENU_AGENCY_IDS = new Set([
  'a48fc52e-bf1f-448c-bb4b-12465b4126cd',
  '3667dddd-7631-4258-bea0-74529fef9451',
]);

export function isMarketplaceMenuEnabled(): boolean {
  const agencyId = (localStorage.getItem('NCAgencyId') || '').trim().toLowerCase();
  return MARKETPLACE_MENU_AGENCY_IDS.has(agencyId);
}

/**
 * Review Queue: super users, plus any login email listed in REACT_APP_REVIEW_QUEUE_EMAILS.
 * Mirrors AMPApi's ReviewQueueEmails check, which also lets super users through.
 */
export function isReviewQueueEnabled(): boolean {
  if (localStorage.getItem('isSuperUser') === 'true') return true;
  const email = (localStorage.getItem('userEmail') || '').toLowerCase();
  return (process.env.REACT_APP_REVIEW_QUEUE_EMAILS || '')
    .split(',')
    .map(e => e.trim().toLowerCase())
    .includes(email);
}

export function isCommissionForecastEnabled(): boolean {
  return localStorage.getItem('isSuperUser') === 'true';
}

/** Agencies (NowCerts agency ids) allowed to see the Dialer. */
const DIALER_AGENCY_IDS = new Set([
  'd0295cb2-9d2b-4670-b08b-ae5452eec8a7',
]);

export function isDialerEnabled(): boolean {
  const agencyId = (localStorage.getItem('NCAgencyId') || '').trim().toLowerCase();
  return DIALER_AGENCY_IDS.has(agencyId);
}
